// Import Modules
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules'
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import axios from 'axios';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// import images
import './favicon/favicon1.png';
import './images/bgimage1.png';
import './images/bgimage4.jpg';
import './images/bgimage6.jpeg';
import './images/bgimage7.png';
import './images/bgimage8.jpg';
import './images/ukflag1.png';
import './images/icon_zoom.png';
import './images/icon_link.png';
import './images/icon_manufacturer.png';
import './images/icon_delivery.png';
import './images/logo1.png';
import './images/logo2.png';
import './images/icon_star1.png';
import './images/icon_star2.png';
import './images/icon_quality1.png';
import './images/icon_quality2.png';
import './images/icon_checkmark.png';

tippy('[data-tippy-content]');

const mobileButtonSetup = () => {

  // site navigation mobile button
  const $siteNavMobileButton = document.querySelector('.site-navigation .mobile-button');
  if($siteNavMobileButton){
    $siteNavMobileButton.addEventListener('click', (event) => {
      
      // prevent default
      event.preventDefault();

      // get site nav
      const $siteNav = document.querySelector('.site-navigation');

      // toggle class
      $siteNav.classList.toggle("open");

    });
  }

}

const npLazyImageSetup = () => {

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio <= 0) return;
      observer.unobserve(entry.target)
      const image = entry.target.querySelector("img");
      const imageNew = new Image();
      image.src = image.dataset.src;
      imageNew.src = image.dataset.src;
      imageNew.onload = function() {
        setTimeout(function(){
          entry.target.classList.remove("active")
        }, 50);
      };
      
      
    });
  });
  const elements = document.querySelectorAll(".np-lazy-image");
  elements.forEach((element) => observer.observe(element));

}

const lpLazyImageSetup = () => {

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio <= 0) return;
      const image = entry.target;
      image.src = image.dataset.src;
      image.onload = function() {
        observer.unobserve(entry.target)
      };
      // const imageNew = new Image();
      // imageNew.src = image.dataset.src;
      // imageNew.onload = function() {
      //   setTimeout(function(){
      //     image.classList.remove("active")
      //   }, 50);
      // };
      
      
    });
  });
  const elements = document.querySelectorAll("[data-src]");
  elements.forEach((element) => observer.observe(element));

}

const swiperSetup = () => {

  const swipers1 = document.querySelectorAll('.swipernav');
  swipers1.forEach((swiper, index) => {
    swiper.classList.add(`swiper${index}`);
    const total = swiper.querySelectorAll(`a`).length;
    new Swiper(`.swiper${index}`, {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 4,
      loop: false,
      navigation: {
        nextEl: `.swiper${index} .swiper-button-next`,
      },
      breakpoints: {
        320: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 5,
        },
        992: {
          slidesPerView: 6,
        },
        1231: {
          slidesPerView: total,
        }
      }
    });
  });

  const swipers2 = document.querySelectorAll('.swiperjumbotron');
  swipers2.forEach((swiper, index) => {
    swiper.classList.add(`swiperjumbo${index}`);
    new Swiper(`.swiperjumbo${index}`, {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: `.swiperjumbo${index} .swiper-button-prev`,
        nextEl: `.swiperjumbo${index} .swiper-button-next`,
      },
    });
  });


}

const lightboxSetup = () => {
  const elements = document.querySelectorAll('.psgallery');
  elements.forEach((element) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: element,
      children: '.psitem',
      pswpModule: PhotoSwipe
    });
    lightbox.init();
  });
}

const npscrolltoSetup = () => {
  const buttons = document.querySelectorAll('.npscrollto');
  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
        
      // prevent default
      event.preventDefault();

      // get id of post
      const id = button.dataset.id;

      // get element to scroll to
      const element = document.getElementById(id);

      // smooth scrolling
      element.scrollIntoView({ behavior: 'smooth' });

      console.log(id);

    });
  });
}

const npformSetup = () => {
 
  // get all forms elements
  const forms = document.querySelectorAll('.npform');
  
  // add event listener
  forms.forEach((form, index) => {
    form.addEventListener('submit', (event) => {

      // prevent default
      event.preventDefault();

      // get form data
      const formData = new FormData(form);

      // get submit data
      const $submit = form.querySelector(`.submit`);

      // disable submit button
      $submit.disabled=true;

      // submit form data
      axios({
        baseURL: window.location.origin,
        method: "post",
        url: form.dataset.url,
        data: formData,
      }).then(function (response) {
        console.log(response);
        const $response = form.querySelector(`.response`);
        $response.innerHTML = "";
        $response.style.display = "block";
        $response.classList.remove("error");
        $response.classList.add("success");
        const $elm = document.createElement("p");
        $elm.innerHTML = response.data.message
        $response.appendChild($elm);
        if(response.data.redirect) window.location.href = response.data.redirect;
      }).catch((error)=>{
        const $response = form.querySelector(`.response`);
        $submit.disabled=false;
        $response.innerHTML = "";
        $response.style.display = "block";
        $response.classList.add("error");
        $response.classList.remove("success");
        if(error.response.status === 400 && error.response.data.length){
          error.response.data.forEach(value=>{
            const $elm = document.createElement("p");
            $elm.innerHTML = value.message
            $response.appendChild($elm);
          })
        }
        if(error.response.status === 500 || error.response.status === 401){
          const $elm = document.createElement("p");
          $elm.innerHTML = error.response.data.message
          $response.appendChild($elm);
        }
      });

    });
  });

}

const npProductLinkSetup = () => {
  const buttons = document.querySelectorAll('.product .icon-link');
  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
        
      // prevent default
      event.preventDefault();

      // get id of post
      const href = button.dataset.href;

      // redirect
      window.open(href, "_blank");

    });
  });
}

const npProductZoomSetup = () => {
  
  const exists = document.querySelector('.container > .products');
  if(exists){

    // set products
    const products = [];
    const $products = document.querySelectorAll('.container > .products > .main > .products > .product');
    for (let i = 0; i < $products.length; i++) {
      const product = {};
      product.src = $products[i].dataset.src;
      product.width = $products[i].dataset.width;
      product.height = $products[i].dataset.height;
      product.href = $products[i].dataset.href;
      product.url = $products[i].dataset.url;
      product.bname = $products[i].dataset.bname;
      product.name = $products[i].dataset.name;
      product.desc = $products[i].dataset.desc;
      products.push(product);
    }

    // Initialize PhotoSwipe
    const lightbox = new PhotoSwipeLightbox({
      dataSource: products,
      showHideAnimationType: 'none',
      pswpModule: PhotoSwipe
    });

    lightbox.on('uiRegister', function() {
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        onInit: (el, pswp) => {
          lightbox.pswp.on('change', () => {

            // get data
            const data = pswp.currSlide.data;

            // Create an anchor element
            const link = document.createElement("a");

            // Set the href attribute
            link.href = data.url;

            // Set the text content (brand name + product name)
            link.textContent = data.bname + ' ' + data.name;

            // Optionally, set the target to open in a new tab
            link.target = "_blank";

            // Append the link to the container
            el.innerHTML = '';
            el.appendChild(link);

          });
        }
      });
    });

    lightbox.init();

    document.querySelectorAll(".product .icon-zoom").forEach((button) => {
      button.addEventListener("click", function (event) {

          // prevent default
          event.preventDefault();

          

          const index = parseInt(this.getAttribute("data-index")); 
          
          lightbox.loadAndOpen(index);
      });
    });


  }


}

lpLazyImageSetup();
swiperSetup();
lightboxSetup();
npscrolltoSetup();
npformSetup();
npProductLinkSetup();
npProductZoomSetup();